import { useState } from 'react';

import { PersonType } from '@/../../backend/src/types/types';
import { TrackingEvents } from '@/analytics/events';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { capitalizeFirstLetter } from '@/helpers/filterNames';
import { FilterModalContent } from '@/new/components/filter-modal-content';
import { Label } from '@/new/components/shadcn/label';
import {
  MultiSelect,
  MultiSelectContent,
  MultiSelectGroup,
  MultiSelectItem,
  MultiSelectTrigger,
  MultiSelectValue,
} from '@/new/components/shadcn/multi-select';
import type { PersonFiltersV2 } from '@/types';

export function EntityFilters({
  activeFilters,
  setFilters,
  handleClose,
  goToPage,
}: {
  activeFilters: PersonFiltersV2;
  setFilters: (v: PersonFiltersV2) => void;
  handleClose: () => void;
  goToPage?: (value: number) => void;
}) {
  const [personTypeFilters, setPersonTypeFilters] = useState<PersonType[]>(activeFilters.personType || []);

  const handleSubmit = () => {
    const newFilters = { ...activeFilters };
    newFilters.personType = personTypeFilters;
    setFilters(newFilters);
    handleClose();
  };

  const handleClear = () => {
    setFilters({
      personType: [],
    });
    handleClose();
  };

  return (
    <FilterModalContent
      title="Filter Entities"
      description="Choose which entities to show"
      onApply={handleSubmit}
      onClear={handleClear}
      goToPage={goToPage}
    >
      <div>
        <Label className="mb-2 block">Entity Types</Label>

        <MultiSelect
          values={personTypeFilters}
          onValuesChange={(values) => {
            trackCustomEvent(TrackingEvents.FilterPersonByType);
            setPersonTypeFilters(values as PersonType[]);
          }}
        >
          <MultiSelectTrigger className="w-full">
            <MultiSelectValue placeholder="Select entity types..." />
          </MultiSelectTrigger>
          <MultiSelectContent>
            <MultiSelectGroup>
              {Object.values(PersonType).map((personType) => (
                <MultiSelectItem key={personType} value={personType}>
                  {capitalizeFirstLetter(personType)}
                </MultiSelectItem>
              ))}
            </MultiSelectGroup>
          </MultiSelectContent>
        </MultiSelect>
      </div>
    </FilterModalContent>
  );
}
